import { __awaiter, __generator } from "tslib";
import { fetchFeedUrls } from './feedUtils';
import { processBindings } from './processBindings';
/**
 * Process Ad based from feed
 */
export var processFeed = function (ad) { return __awaiter(void 0, void 0, void 0, function () {
    var responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!ad.feed) {
                    return [2 /*return*/, ad];
                }
                return [4 /*yield*/, fetchFeedUrls(ad.feed.urls)];
            case 1:
                responses = _a.sent();
                return [2 /*return*/, processBindings({ ad: ad, responses: responses })];
        }
    });
}); };
